import React from 'react';
import { useSelector } from 'react-redux';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { isEditorPage } from '@editor/helpers/';

// TODO: take a look why this component update around 924 times

const BootstrapTooltip = styled(({ className, center, ...props }) => {
  /*
  ? Remove bgColor from props to avoid this warning:
  * React does not recognize the `bgColor` prop on a DOM element
  */
  const tooltipProps = { ...props };
  delete tooltipProps.bgColor;
  return <Tooltip {...tooltipProps} arrow classes={{ popper: className }} />;
})((props) => {
  const { bgColor } = props;

  return {
    zIndex: 1200,
    [`& .${tooltipClasses.arrow}`]: {
      color: bgColor,
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: bgColor,
      // maxWidth: '233px',
      fontSize: '12px',
      fontFamily: 'Montserrat, sans-serif',
      fontWeight: '400',
      textAlign: props?.center ? 'center' : 'left',
    },
  };
});

export default function CustomToolTip({
  children,
  title,
  center,
  open = undefined,
  placement = 'top',
  id,
  style,
  onMouseOver,
  onMouseOut,
  onMouseEnter,
  onMouseLeave,
}) {
  const isColorblind = useSelector((state) => state.editor?.isColorblind);

  return (
    <div>
      <BootstrapTooltip
        center={center}
        open={open}
        title={title}
        placement={placement}
        id={id}
        style={style}
        bgColor={isEditorPage() && isColorblind ? '#737373' : '#505876'}
        onMouseOver={onMouseOver}
        onMouseOut={onMouseOut}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        <div className='cursor-pointer'>{children}</div>
      </BootstrapTooltip>
    </div>
  );
}
CustomToolTip.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  placement: PropTypes.string,
  open: PropTypes.bool,
  center: PropTypes.bool,
  id: PropTypes.string,
  style: PropTypes.object,
  onMouseOver: PropTypes.func,
  onMouseOut: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
};
